import { IRootState } from '@/store';
import { GetterTree } from 'vuex';
import { ILieferantenState } from './state';

export const RECHNUNGEN = 'getRechnungen';
export const RECHNUNGDETAILS = 'getRechnungDetails';
export const LOADING = 'getLoading';
export const TOTAL_NUMBER_OF_RECORDS = 'getTotalNumberOfRecords';
export const GET_TVS_KUNDEN_VON_LIEFERANT = 'getTvsKundenVonLieferant';
export const GET_TVS_KUNDEN_LISTE = 'getTvsKundenListe';
export const GET_TVS_KUNDEN_TOTAL_NUMBER_OF_RECORDS = 'getTvsKundenTotalNumberOfRecords';
export const GET_TVS_KUNDEN_LOADING = 'getTeilnehmerLoading';
export const GET_LIEFERANTEN_DOKUMENTE = 'getLieferantenDokumente';
export const LIEFERANTEN_DOKUMENTE_TOTAL_NUMBER_OF_RECORDS = 'getLieferantenDokumenteTotalNumberOfRecords';
export const DOKUMENTE_LOADING = 'getDokumenteLoading';
export const FEHLERHAFTE_RECHNUNGEN = 'getFehlerhafteRechnungen';
export const GETLIEFERANTDETAILDATA = 'getLieferantDetailData';
export const GET_TVS_KUNDE_DETAILS = 'getTvsKundeDetails';
export const GET_UNITS_OF_MEASUREMENT = 'getUnitsOfMeasurement';
export const GET_MWST_SATZ_LIST = 'getMwstSatzList';

export const getters: GetterTree<ILieferantenState, IRootState> = {
    [RECHNUNGEN]: (state) => state.rechnungList,
    [RECHNUNGDETAILS]: (state) => state.rechnungenDetails,
    [LOADING]: (state) => state.loading,
    [TOTAL_NUMBER_OF_RECORDS]: (state) => state.totalNumberOfRecords,
    [GET_TVS_KUNDEN_VON_LIEFERANT]: (state) => state.tvsKundenVonLieferant,
    [GET_TVS_KUNDEN_LISTE]: (state) => state.tvsKundenListe,
    [GET_TVS_KUNDEN_TOTAL_NUMBER_OF_RECORDS]: (state) => state.tvsKundenTotalNumberOfRecords,
    [GET_TVS_KUNDEN_LOADING]: (state) => state.tvsKundenLoading,
    [GET_LIEFERANTEN_DOKUMENTE]: (state) => state.lieferantenDokumentList,
    [LIEFERANTEN_DOKUMENTE_TOTAL_NUMBER_OF_RECORDS]: (state) => state.lieferantenDokumenteTotalNumberOfRecords,
    [DOKUMENTE_LOADING]: (state) => state.dokumenteLoading,
    [FEHLERHAFTE_RECHNUNGEN]: (state) => state.fehlerhafteRechnungList,
    [GETLIEFERANTDETAILDATA]: (state) => state.lieferantDetailData,
    [GET_TVS_KUNDE_DETAILS]: (state) => state.tvsKundeDetails,
    [GET_UNITS_OF_MEASUREMENT]: (state) => state.unitsOfMeasurement,
    [GET_MWST_SATZ_LIST]: (state) => state.mwstSatzList
};
